/** Application-owned destinations. Model output must never become a URL or record ID. */
export const ASSISTANT_DESTINATIONS = {
  certificate_upload: [
    { role: 'user', label: 'Upload Certificate', path: '/user/certificates/upload' },
  ],
  certificates: [
    { role: 'user', label: 'Certificates', path: '/user/certificates' },
    { role: 'approver', label: 'Certificates', path: '/approver/certificates' },
    { role: 'admin', label: 'Certificate Repository', path: '/admin/cert-repository' },
  ],
  requests: [
    { role: 'user', label: 'My Requests', path: '/user/requests' },
    { role: 'admin', label: 'Requests', path: '/admin/requests' },
  ],
  hub_ca_chain: [{ role: 'user', label: 'Hub CA Chain', path: '/user/hub-ca-chain' }],
  organization: [
    { role: 'user', label: 'Organization', path: '/user/organization' },
    { role: 'admin', label: 'Organizations', path: '/admin/organizations' },
  ],
  approvals: [{ role: 'approver', label: 'Approvals', path: '/approver/approvals' }],
  scheduled_changes: [
    { role: 'approver', label: 'Scheduled Changes', path: '/approver/scheduled-changes' },
  ],
  support: [],
} as const;

export type AssistantNavigationTarget = keyof typeof ASSISTANT_DESTINATIONS;
export interface AssistantScreenLink {
  readonly label: string;
  readonly path: string;
}

export function isAssistantNavigationTarget(value: unknown): value is AssistantNavigationTarget {
  return typeof value === 'string' && Object.hasOwn(ASSISTANT_DESTINATIONS, value);
}

/** Presentation filtering only. Existing route guards and backend authorization remain authoritative. */
export function assistantScreenLinks(
  targets: readonly AssistantNavigationTarget[],
  roles: readonly string[],
): readonly AssistantScreenLink[] {
  return [...new Set(targets)].flatMap((target) => {
    const screen = ASSISTANT_DESTINATIONS[target].find((candidate) =>
      roles.includes(candidate.role),
    );
    return screen ? [{ label: screen.label, path: screen.path }] : [];
  });
}
